var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Iconsvg } from '../iconsvg';
import { ButtonFieldIconClosePrivate } from '../button-field-icon-close-private';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
export var DEFAULT_NOTIFICATION_I18N = {
    closeButtonAriaLabel: 'Dismiss alert',
};
export var DEFAULT_AUTOCLOSE_TIME = 5000;
var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    function Notification(props) {
        var _this = _super.call(this, props) || this;
        _this.emit = componentApi.emit.bind(_this);
        _this.writeState = componentApi.writeState.bind(_this);
        _this.templates = [
            { name: 'notificationContent', description: 'The notification content.' },
            { name: 'notificationActions', description: 'The notification actions.' },
        ];
        _this.runningAutoCloseId = null;
        _this.runningAnimatedActivateId = null;
        _this.cgRequestAnimationFrame = componentApi.cgRequestAnimationFrame.bind(_this);
        _this.toCancel = [];
        _this.cgSetTimeout = componentApi.cgSetTimeout.bind(_this);
        _this.userRequest = 'onUserRequest';
        _this.openBegin = 'onOpenBegin';
        _this.openEnd = 'onOpenEnd';
        _this.closeBegin = 'onCloseBegin';
        _this.closeEnd = 'onCloseEnd';
        _this.readTemplate = componentApi.readTemplate.bind(_this);
        _this.state = {};
        _this.state['_isInDOM'] = false;
        _this.state['_isOpen'] = false;
        _this.transitionEnd = _this.transitionEnd.bind(_this);
        _this.onDismissButtonClick = _this.onDismissButtonClick.bind(_this);
        return _this;
    }
    Notification.prototype.render = function () {
        var _this = this;
        return this.state._isInDOM ? (React.createElement("div", { "data-e2e": this.props.dataE2e, role: "alert", onTransitionEnd: function (event) { return _this.transitionEnd(event); }, className: 'cg-notification ' +
                (this.props.mode == 'toast' ? 'cg-notification-toast ' : '') +
                (this.props.type === 'info' ? 'cg-notification-info ' : '') +
                (this.props.type === 'error' ? 'cg-notification-error ' : '') +
                (this.props.type === 'warning' ? 'cg-notification-warning ' : '') +
                (this.props.type === 'success' ? 'cg-notification-success ' : '') +
                (!this.state._isOpen ? 'cg-element-hidden ' : '') +
                (this.props.hasAnimation ? 'cg-element-animation ' : '') },
            React.createElement(Iconsvg, { isFill: true, size: 16, name: this.getNotificationTypeIconName() }),
            !!this.props.heading ? (React.createElement("div", { className: "cg-notification-title" }, this.props.heading)) : null,
            React.createElement("div", { "data-e2e": "cg-notification-content", className: 'cg-notification-content ' +
                    (this.props.isLineClampUnset ? 'cg-has-no-line-clamp ' : '') }, this.readTemplate('notificationContent')[0]),
            this.props.hasCloseButton ? (React.createElement(ButtonFieldIconClosePrivate, null,
                React.createElement("button", { type: "button", "data-e2e": "cg-notification-dismiss", "aria-label": this.props.i18n.closeButtonAriaLabel, onClick: function (event) { return _this.onDismissButtonClick(event); }, className: "cg-notification-dismiss" },
                    React.createElement(Iconsvg, { isFill: true, size: 16, name: "close" })))) : null,
            this.readTemplate('notificationActions')[0])) : null;
    };
    Notification.prototype.cg_change = function (prevProps) {
        var _this = this;
        if (prevProps.isOpen === false && this.props.isOpen === true) {
            if (this.state._isInDOM === false) {
                this.attachToDOM();
            }
            else {
                this.animatedActivate();
            }
        }
        if (prevProps.isOpen === true && this.props.isOpen === false) {
            this.cancelPendingAnimation();
            this.animatedDeactivate();
        }
        if (prevProps['_isInDOM'] === false && this.state._isInDOM === true) {
            this.cancelPendingAnimation();
            // This RAF seems to let DOM get rendered
            // after _isInDOM was set to true.
            // interesting that for react16 we need only one RAF, but for angular17 RAF inside RAF
            this.runningAnimatedActivateId = this.cgRequestAnimationFrame(function () {
                _this.runningAnimatedActivateId = _this.cgRequestAnimationFrame(function () {
                    _this.animatedActivate();
                });
            });
        }
        if (prevProps.autoCloseTimeout !== undefined &&
            prevProps.autoCloseTimeout !== this.props.autoCloseTimeout) {
            this.cancelAutoClose();
            this.setAutoClose();
        }
    };
    Notification.prototype.getNotificationTypeIconName = function () {
        var iconMap = {
            info: 'info',
            error: 'stop-sign',
            success: 'check-circle',
            warning: 'caution',
        };
        var notificationType = this.props.type;
        return iconMap[notificationType];
    };
    Notification.prototype.onDismissButtonClick = function (event) {
        this.handleClose();
    };
    Notification.prototype.transitionEnd = function (event) {
        if (event.propertyName !== 'transform') {
            return;
        }
        if (this.state._isOpen) {
            this.emit(this.openEnd);
            return;
        }
        this.emit(this.closeEnd);
        this.detachFromDOM();
    };
    Notification.prototype.animatedActivate = function () {
        this.emit(this.openBegin);
        this.open();
        this.cancelAutoClose();
        this.setAutoClose();
    };
    Notification.prototype.animatedDeactivate = function () {
        this.emit(this.closeBegin);
        this.close();
        this.cancelAutoClose();
    };
    Notification.prototype.cancelPendingAnimation = function () {
        cancelAnimationFrame(this.runningAnimatedActivateId);
        this.runningAnimatedActivateId = null;
    };
    Notification.prototype.cancelAutoClose = function () {
        clearTimeout(this.runningAutoCloseId);
        this.runningAutoCloseId = null;
    };
    Notification.prototype.getAutoCloseTimeout = function () {
        if (this.props.autoCloseTimeout !== null) {
            return this.props.autoCloseTimeout;
        }
        var type = this.props.type;
        if (type === 'info' || type === 'success') {
            return DEFAULT_AUTOCLOSE_TIME;
        }
        return 0;
    };
    Notification.prototype.setAutoClose = function () {
        var _this = this;
        var autoCloseTimeout = this.getAutoCloseTimeout();
        if (autoCloseTimeout > 0 && this.props.isOpen) {
            this.runningAutoCloseId = this.cgSetTimeout(function () {
                _this.handleClose();
            }, autoCloseTimeout);
        }
    };
    Notification.prototype.isControlled = function () {
        return this.props.controlMode === 'controlled';
    };
    Notification.prototype.handleClose = function () {
        if (this.state._isOpen) {
            var newState = false;
            if (this.isControlled()) {
                this.emit(this.userRequest, newState);
            }
            else {
                this.emit(this.userRequest, newState);
                this.cancelPendingAnimation();
                this.animatedDeactivate();
                if (!this.props.hasAnimation) {
                    this.detachFromDOM();
                }
            }
        }
    };
    Notification.prototype.attachToDOM = function () {
        this.writeState('_isInDOM', true);
    };
    Notification.prototype.detachFromDOM = function () {
        this.writeState('_isInDOM', false);
    };
    Notification.prototype.open = function () {
        this.writeState('_isOpen', true);
    };
    Notification.prototype.close = function () {
        this.writeState('_isOpen', false);
    };
    Notification.prototype.componentDidMount = function () {
        if (this.props.isOpen) {
            this.attachToDOM();
        }
    };
    Notification.prototype.componentWillUnmount = function () {
        this.toCancel.forEach(function (cancelableFunc) {
            cancelableFunc();
        });
    };
    Notification.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    Notification.defaultProps = {
        dataE2e: 'cg-notification',
        heading: '',
        hasAnimation: true,
        type: 'info',
        isLineClampUnset: false,
        controlMode: 'uncontrolled',
        isOpen: true,
        mode: 'normal',
        i18n: DEFAULT_NOTIFICATION_I18N,
        autoCloseTimeout: null,
        hasCloseButton: true,
    };
    Notification.displayName = 'Notification';
    return Notification;
}(React.Component));
export { Notification };
